<template>
  <div class="baogao-list">
    <div class="baogao-list-top">
      <div class="title" @click="showCalendar=true">请选择日期：</div>
      <div class="date" @click="showCalendar=true"><span>{{ date }}</span><van-icon class="iconclass" name="play" /></div>
    </div>
    <!-- <div class="title" @click="showCalendar=true">请选择日期<span v-if="date">:</span>{{date}}<van-icon v-if="!date" class="iconclass" name="play" /></div> -->
    <van-calendar
      v-model="showCalendar"
      :min-date="minDate"
      :max-date="maxDate"
      :style="{ height: '70vh' }"
      type="range"
      :allow-same-day="true"
      color="#1989fa"
      @confirm="onConfirm"
    />
    <van-tabs v-model="activeName">
      <van-tab title="检查项目" name="1">
        <!-- <van-list
          v-model="jcLoading"
          :finished="jcFinished"
          :finished-text="jcList.length ? '' : '暂无数据'"
          :immediate-check="false"
          @load="jcOnLoad"
        >
        <div class="gj-list" v-for="item in jcList" :key="item.id" @click="toJcDetail(item)">
            <div class="list-item">
              <span class="item-title">检查项目：</span>
              <span class="item-value">{{item.studyscripTion}}</span>
            </div>
            <div class="list-item">
              <span class="item-title">报告时间：</span>
              <span class="item-value">{{item.studyTime}}</span>
            </div>
          </div>
        </van-list> -->
        <van-loading v-show="jcLoading" class="my-loading" type="spinner" color="#1989fa" />
        <van-cell-group v-show="jcList.length > 0 && !jcLoading" size="large">
          <van-cell v-for="item in jcList" :key="item.id" center :title="item.studyscripTion" :label="item.studyTime" is-link @click="toJcDetail(item)" />
        </van-cell-group>
        <noData v-show="jcList.length === 0 && !jcLoading" title="暂无检查报告" />
      </van-tab>
      <van-tab title="检验项目" name="2">
        <!-- <van-list
          v-model="jyLoading"
          :finished="jyFinished"
          :finished-text="jyList.length ? '' : '暂无数据'"
          :immediate-check="false"
          @load="jyOnLoad"
        >
        <div class="gj-list" v-for="item in jyList" :key="item.id" @click="toDetail(item.allBarCodes, item.patientName)">
            <div class="list-item">
              <span class="item-title">检查项目：</span>
              <span class="item-value">{{item.doctorAdvice}}</span>
            </div>
            <div class="list-item">
              <span class="item-title">报告时间：</span>
              <span class="item-value">{{item.reportDate}}</span>
            </div>
          </div>
        </van-list> -->
        <van-loading v-show="jyLoading" class="my-loading" type="spinner" color="#1989fa" />
        <van-cell-group v-show="jyList.length > 0 && !jyLoading" size="large">
          <van-cell v-for="item in jyList" :key="item.id" center :title="item.doctorAdvice" :label="item.reportDate" is-link @click="toDetail(item)" />
          <!-- <div class="yifabu">
            已发布
            </div> -->
        </van-cell-group>
        <noData v-show="jyList.length === 0 && !jyLoading" title="暂无检验报告" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: 'BaogaoList',
  data() {
    return {
      date: '',
      showCalendar: false,
      minDate: new Date('2020/1/1'),
      maxDate: new Date(),
      startDate: '',
      endDate: '',
      hisPatientId: '',
      id: '',
      jyLoading: false,
      jcLoading: false,
      jyFinished: false,
      jcFinished: false,
      activeName: '1',
      jcCurrent: 1,
      jyCurrent: 1,
      pageSize: 10,
      jcList: [],
      jyList: []
    }
  },
  watch: {
    '$route': {
      handler: function(to, from) {
        if (from && from.path === '/myPatient') {
          Object.assign(this.$data, this.$options.data())
          this.ageCreated()
        }
      }
    }
  },
  created() {
    this.ageCreated()
  },
  mounted() {},
  methods: {
    ageCreated() {
      const startDate = this.formatDate(new Date(new Date().getTime() - 30 * 24 * 3600000))
      const endDate = this.formatDate(new Date())
      this.date = `${startDate}~${endDate}`
      this.startDate = startDate
      this.endDate = endDate
      this.id = this.$route.query.id
      this.hisPatientId = this.$route.query.hisPatientId
      this.blhNo = this.$route.query.blhNo
      this.getList()
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onConfirm(date) {
      const [start, end] = date
      this.showCalendar = false
      this.date = `${this.formatDate(start)}/${this.formatDate(end)}`
      this.startDate = this.formatDate(start)
      this.endDate = this.formatDate(end)
      this.getList()
    },
    getList() {
      this.getInspectListPage()
      this.getInspectionListPage()
    },
    // 检查报告
    getInspectListPage() {
      const str = localStorage.getItem('userInfo')
      const idUse = JSON.parse(str)
      this.jcLoading = true
      const obj = {
        blNo: this.blhNo,
        startDate: this.startDate,
        endDate: this.endDate,
        patientID: this.hisPatientId,
        userId: idUse.id
      }
      this.$Apis.getInspectReport(obj).then(res => {
        this.jcLoading = false
        if (res.code === 200) {
          this.jcList = res.data.result || []
          this.jcFinished = true
        } else {
          this.jcFinished = true
        }
      }).catch(() => {
        this.jcLoading = false
        this.jcFinished = true
      })
    },
    // 检验报告
    getInspectionListPage() {
      
      const str = localStorage.getItem('userInfo')
      const idUse = JSON.parse(str)
      this.jyLoading = true
      const obj = {
        patientId: this.blhNo,
        startTime: this.startDate,
        endTime: this.endDate,
        userId: idUse.id
      }
      this.$Apis.getGjyyReportList(obj).then(res => {
        this.jyLoading = false
        if (res.code === 200) {
          this.jyList = res.data.tables || []
          this.jyFinished = true
        } else {
          this.jyFinished = true
        }
      }).catch(() => {
        this.jyLoading = false
        this.jyFinished = true
      })
    },
    jcOnLoad() {
      this.jcCurrent++
      this.getInspectListPage()
    },
    jyOnLoad() {
      this.jyCurrent++
      this.getInspectionListPage()
    },
    toJcDetail(item) {
      this.$router.push(`/baogaoJcDetail?id=${item.pacsStudyuniqueid}`)
      localStorage.setItem('baogaoJcDetail', JSON.stringify(item))
    },
    toDetail(item) {
      localStorage.setItem('baogaoDetail', JSON.stringify(item))
      this.$router.push(`/baogaoDetail?reportNo=${item.allBarCodes}&patientName=${item.patientName}`)
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.baogao-list{
  margin: 0 .15rem;
  &-top{
    height: 1.25rem;
    background: url('../../assets/images/bg-top-bj.png') center center no-repeat;
    background-size: cover;
    padding: 0 0 0 .15rem;
    margin-bottom: .15rem;
    display: flex;
    flex-flow: column;
    justify-content: center;
    color: #FFFFFF;
    font-size: .18rem;
    .title{
      margin-bottom: .1rem;
    }
    .date{
      span{
        margin-right: .05rem;
      }
      .iconclass{
        transform: rotateZ(90deg);
      }
    }
  }
  /deep/.van-tabs__line{
    background-color: #2B8CFF;
  }
  /deep/.van-tab--active{
    color: #2B8CFF;
  }
}
</style>
